export {default} from './RegistrationVerificationForm';



// WEBPACK FOOTER //
// ./src/containers/RegistrationVerificationForm/index.ts